import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";

const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_design-fasaad/artifacts/3eeule3e_FaSaaD%20MiMAR.png";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="footer-editorial bg-[#F5F5F3]">
      <div className="max-w-screen-2xl mx-auto px-16 lg:px-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block mb-8">
              <img 
                src={LOGO_BLACK}
                alt="FaSaad Mimar"
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-sm text-[#737373] leading-relaxed max-w-sm">
              Award-winning architecture and design studio based in Istanbul. 
              Recognized among 25 Under 25 Top Global Talents in Innovation, 2020.
            </p>
          </div>

          <div className="lg:col-span-3">
            <span className="label-caps block mb-6">Navigation</span>
            <nav className="flex flex-col gap-4">
              <Link to="/" className="text-sm hover:opacity-60 transition-opacity" data-testid="footer-link-work">Work</Link>
              <Link to="/about" className="text-sm hover:opacity-60 transition-opacity" data-testid="footer-link-studio">Studio</Link>
              <Link to="/contact" className="text-sm hover:opacity-60 transition-opacity" data-testid="footer-link-contact">Contact</Link>
              <Link to="/appointment" className="text-sm hover:opacity-60 transition-opacity" data-testid="footer-link-appointment">Book</Link>
            </nav>
          </div>

          <div className="lg:col-span-4">
            <span className="label-caps block mb-6">Get in Touch</span>
            <div className="space-y-4">
              <a 
                href="mailto:info@saadmimar.com" 
                className="flex items-center gap-2 text-sm hover:opacity-60 transition-opacity"
                data-testid="footer-email"
              >
                info@saadmimar.com
                <ArrowUpRight size={14} />
              </a>
              <a 
                href="tel:+905528259634" 
                className="flex items-center gap-2 text-sm hover:opacity-60 transition-opacity"
                data-testid="footer-phone"
              >
                +90 552 825 9634
                <ArrowUpRight size={14} />
              </a>
              <p className="text-sm text-[#737373]">
                Kagithane, Istanbul<br />Türkiye
              </p>
              <a
                href="https://www.instagram.com/fasaadmimar/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm hover:opacity-60 transition-opacity mt-4"
                data-testid="footer-instagram"
              >
                <Instagram size={16} />
                @fasaadmimar
              </a>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-[#E0E0DE] flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-[#737373]">
            © {new Date().getFullYear()} FaSaad Mimar
          </p>
          <span className="text-xs text-[#737373] flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
            Available for projects
          </span>
        </div>
      </div>
    </footer>
  );
};
